import { put, call } from 'redux-saga/effects';
import { fetchWithMisToken } from '../../../../utils/fetch-with-mis-token';
import {
    FETCH_SEASON_LEADERS,
    setSeasonLeaders
} from '../actions';

/**
 * @typedef {object} FetchSeasonLeadersAction
 * @property {object} payload
 * @property {string} payload.seasonId
 */

/**
 * @param {FetchSeasonLeadersAction} action - The Redux action.
 */
export function* fetchSeasonLeaders( action ) {
    const data = yield call(
        fetchWithMisToken,
        // @ts-ignore
        `${ PULSE.app.environment.statsPro }/leadingPlayerStats/season/${ action.payload.seasonId }?limit=5`
    );
    
    yield put( setSeasonLeaders( data ) );

    yield put( FETCH_SEASON_LEADERS.success( data ) );
}